import { createFileRoute } from "@tanstack/react-router";

import LeadsList from "@/pages/LeadsList";

export const Route = createFileRoute("/_authenticated/lead/list")({
  component: LeadsList,
});
